import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { WithStyles, Theme, createStyles, withStyles, Typography, Icon } from '@material-ui/core'
import { NewsCriteria } from 'src/type/criteria/newsCriteria'
import { fetchNews, fetchNewsEcoWatch } from 'src/core/redux/action/newsAction'
import autobind from 'autobind-decorator'
import EcoWatchCard from 'src/page/Consumer/EcoWatch/EcoWatchCard'
import { EcoWatchAction } from 'src/core/redux/action/ecoWatchAction'
import { IconBtn } from 'src/shared/IconBtn'
import {css} from 'src/conf/style'

const styles = (t: Theme) => createStyles({
  root:{
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between'
  },
  bar: {
    ...css.flexFullCenter,
    padding: t.spacing.unit,
    cursor: 'pointer'
  },
  news: {
    flexGrow: 2
  },
  btn: {
      borderRadius: 0,
      margin: `${t.spacing.unit}px 0`,
      color: t.palette.primary.main
  },
  disabled: {
      pointerEvents: 'none',
      color: '#f7f7f7 !important'
  },
  title: {
    ...css.flexFullCenter,
    minHeight: `${8*t.spacing.unit}px`,
    marginBottom: t.spacing.unit,
    color: t.palette.primary.main,
  }
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  dispatch: any;
  filter?: string;
}

const ecoWatchName = 'newsHEBDO';
const ecoWatchAction = fetchNewsEcoWatch;
const actions = new EcoWatchAction<any>(ecoWatchName, ecoWatchAction)

class NewsPME extends React.Component<IProps, {}> {

  componentDidMount(){
      const {updateCriteriaByObject} = this.props
      updateCriteriaByObject(
        {
            "category_actu": "economique,NOTpme-change,NOTpme-dette,NOTpme-placement,NOTpoints,NOTfocus,NOTperspectives", 
            "acategory_actu_nuage": "",
            "category_produit": "",
            "category_principale": ""
        }, 
           "HEBDO"
        )
  }

  render() {
    const {t, classes, newsHEBDO, criteriaHEBDO} = this.props
    return (
        <>
        {newsHEBDO &&
            <div className={classes.root}>  
                <Typography variant="h6" align="center" className={classes.title}>{t.news_HEBDO}</Typography>
                <Typography variant="caption" align="center" className="text-italic">
                  Retour sur une semaine d'actualité <br/> économique
                </Typography>
                <IconBtn
                    onClick={this.fetchBefore}
                    className={[classes.btn, criteriaHEBDO.offset === 0 ? classes.disabled : ''].join(' ')}
                >
                    <Icon fontSize="large">keyboard_arrow_up</Icon>
                </IconBtn>
                <div className={classes.news}>
                    <EcoWatchCard key="news-pme" entities={newsHEBDO} />
                </div>
                <IconBtn 
                    onClick={this.fetchAfter}
                    className={[classes.btn, newsHEBDO.length < 2 ? classes.disabled : ''].join(' ')}
                >
                    <Icon fontSize="large">keyboard_arrow_down</Icon>
                </IconBtn>
            </div>
        }
        </>
    )
  }

  @autobind
  private fetchBefore(){
    this.props.updateCriteria("offset", this.props.criteriaHEBDO.offset - 2, "HEBDO")
  }

  @autobind
  private fetchAfter(){
    this.props.updateCriteria("offset", this.props.criteriaHEBDO.offset + 2, "HEBDO")
  }

}

const state2props = (state: RootState) => ({
    criteriaHEBDO: state.ecoWatch.newsHEBDO.criteria,
    newsHEBDO: state.ecoWatch.newsHEBDO.entities
});

const dispatch2props = (dispatch: any) => ({
    updateCriteria: (name: string, value: any, tags: string) => dispatch(actions.updateCriteria(name, value, tags)),
    updateCriteriaByObject: (object: any, tags: string) => dispatch(actions.updateCriteriaByObject(object, tags)),
    search: (c: NewsCriteria) => dispatch(fetchNews(c)),
    fetch: (c:NewsCriteria, tagPrincipal: string) => dispatch(fetchNewsEcoWatch(c,tagPrincipal))
});

export default compose(
    withI18n,
    withStyles(styles),
    connect(state2props, dispatch2props),
)(NewsPME)



// WEBPACK FOOTER //
// ./src/page/Consumer/EcoWatch/News/NewsHEBDO.tsx